import "../../../Styles/tab.component.css";

import { Paper, Tabs } from "@mantine/core";
import { useState } from "react";
import BreadcrumbLayout1 from "../../../_base/component/_layout/_breadcrumb";
import DMSaleChannel from "../Commodities/DMSaleChannel/DMSaleChannel";
import DMUomCode from "../Commodities/DMUomCode/DMUomCode";
import DMDeliveryMethod from "./DMDeliveryMethod/DMDeliveryMethod";
import DMOrderType from "./DMOrderType/DMOrderType";
import ItemNotes from "./ItemNotes/ItemNotes";

const Commodities = () => {
  const [activeTab, setActiveTab] = useState<string | null>("deliverymethod");
  const breadCrumb = false;

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "0px 10px",
        }}
      >
        <BreadcrumbLayout1></BreadcrumbLayout1>
      </div>
      <Paper shadow="md" radius="lg">
        <Tabs p={"xs"} value={activeTab} onChange={setActiveTab}>
          <Tabs.List>
            <Tabs.Tab value="deliverymethod">Danh mục cách giao hàng</Tabs.Tab>
            <Tabs.Tab value="uomCode">Danh mục đơn vị tính</Tabs.Tab>
            <Tabs.Tab value="saleChannel">Danh mục kênh bán hàng</Tabs.Tab>
            <Tabs.Tab value="orderType">Danh mục loại đơn hàng</Tabs.Tab>
            <Tabs.Tab value="itemNotes">Ghi chú hàng hóa</Tabs.Tab>
            {/* <Tabs.Tab value="supplies">Danh mục vật tư</Tabs.Tab> */}
          </Tabs.List>

          <Tabs.Panel value="deliverymethod">
            {activeTab === "deliverymethod" ? <DMDeliveryMethod /> : <></>}
          </Tabs.Panel>
          <Tabs.Panel value="uomCode">
            {activeTab === "uomCode" ? <DMUomCode /> : <></>}
          </Tabs.Panel>
          <Tabs.Panel value="saleChannel">
            {activeTab === "saleChannel" ? <DMSaleChannel /> : <></>}
          </Tabs.Panel>
          <Tabs.Panel value="orderType">
            {activeTab === "orderType" ? <DMOrderType /> : <></>}
          </Tabs.Panel>
          <Tabs.Panel value="itemNotes">
            {activeTab === "itemNotes" ? <ItemNotes /> : <></>}
          </Tabs.Panel>
          {/* <Tabs.Panel value="supplies">
            {activeTab === "supplies" ? (
              <CategoryCombination breadCrumb={breadCrumb} />
            ) : (
              <></>
            )}
          </Tabs.Panel> */}
        </Tabs>
      </Paper>
    </>
  );
};

export default Commodities;
